<template>
  <div class='widget-W0075V0001'>
    <div v-if="userProfile === 'employee'">
      <!-- TOP PANEL - LOADING WRAPPER -->
      <b-container v-if="municipalities.length === 0 && !isServiceMode">
        <b-row>
          <b-col class="text-center">
            <b-spinner></b-spinner>
            <div>{{translations.loadingText}}{{translations.widgetTitle}}</div>
          </b-col>
        </b-row>
      </b-container>
      <!-- TOP PANEL - SERVICE WINDOW -->
      <b-container v-else-if="isServiceMode === true">
        <b-row >
          <b-col class="text-center">
            <h1>
              <i class="fa fa-wrench service"></i>
            </h1>
            <div>{{translations.serviceWindowMessage}}</div>
          </b-col>
        </b-row>
      </b-container>
      <!-- TOP PANEL - MANY MUNICIPALITIES -->
      <b-container v-else-if="municipalities.length > 2 && !isServiceMode">
        <b-row>
          <b-col>
            <b-form-select v-model="selectedMunicipalityId" :options="municipalities"></b-form-select>
          </b-col>
        </b-row>
        <b-row >
          <b-col>
            <h1
              v-b-popover.hover.top = "translations.refreshWidgetText"
              id="refreshTitle"
              class="text-center"
              @click="refreshWidget"
            >{{ translations.widgetTitle }}</h1>
          </b-col>
        </b-row>
      </b-container>
      <!-- TOP PANEL - ONE MUNICIPALITY -->
      <b-container v-else-if="municipalities.length === 2 && !isServiceMode">
        <b-row >
          <b-col>
            <h1
              v-b-popover.hover.top = "translations.refreshWidgetText"
              id="refreshTitle"
              class="text-center"
              @click="refreshWidget"
            >{{ translations.widgetTitle }}</h1>
          </b-col>
        </b-row>
      </b-container>
      <!-- TOP PANEL - NO MUNICIPALITIES FOUND -->
      <b-container v-else-if="municipalities.length === 1 && !isServiceMode">
        <b-row >
          <b-col class="text-center">
            <h1 class="error">{{translations.errors.generic}}</h1>
            <div>{{translations.errors.membershipError}}</div>
          </b-col>
        </b-row>
      </b-container>

      <!-- BOTTOM AREA WRAPPER -->
      <b-container v-if="(municipalities.length > 0 && assuranceLevel === 2 && !!checkAssuranceLevel) && !isServiceMode">
        <b-row>
          <b-col>
            <b-alert show variant="danger">
              <b-row >
                <b-col>
                  <p>{{translations.assuranceLevelWarningText}}</p>
                </b-col>
              </b-row>
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col align="center">
            <b-button
              variant="primary"
              @click="triggerStepUp"
            >{{translations.assuranceLevelLoginButtonText}}</b-button>
          </b-col>
        </b-row>
      </b-container>
      <b-container v-else-if="(assuranceLevel === 3 || assuranceLevel === 2 && !checkAssuranceLevel) && !isServiceMode">
        <!-- ERROR AREA -->
        <b-row>
          <b-col>
            <b-alert v-model="showErrorAlert" variant="danger" dismissible>
              <p class="error">{{errorAlertMessage}}</p>
            </b-alert>
          </b-col>
        </b-row>

        <b-row v-if="municipalities.length > 1">
          <b-col>
            <!-- SEARCH -->
            <b-container>
              <!-- Title -->
              <b-row>
                <b-col>
                  <h5>
                    {{translations.searchTitle}}
                    <b-spinner
                      v-if="selectedMunicipalityId !== null && searchData.length === 0 && loadingSearch === true"
                      class="align-middle"
                    ></b-spinner>
                  </h5>
                </b-col>
              </b-row>
              <!-- TypeAhead input -->
              <b-row>
                <b-col>
                  <div role="group" class="input-group search-input-group">
                    <b-form-input
                      type="text"
                      class="form-control"
                      id="searchForm"
                      @keydown.down="down"
                      @keydown.up="up"
                      @keyup.enter="findGroupOrStudent"
                      @blur="handleSearchFocusOut"
                      @focus="getStudentsAndGroups"
                      v-model="searchTerm"
                      :placeholder="translations.findPupilOrClassText"
                      :state="searchStatus"
                      :disabled="selectedMunicipalityId === null || searchData.length === 0"
                      @keyup="getStudentsAndGroups"
                      autocomplete="off"
                    ></b-form-input>
                    <span
                      v-show="selectedMunicipalityId !== null && searchData.length > 0"
                      class="icon-Aula_search"
                    ></span>
                  </div>
                  <ul id="typeAheadContainer" v-show="!!this.searchTerm && this.searchTerm.length > 1">
                    <li
                      id="typeAheadResult"
                      v-for="(groupOrStudent, $groupOrStudent) in filteredSearchItems"
                      :class="setActiveCssClass($groupOrStudent)"
                      @mousemove="setActive($groupOrStudent)"
                      @mousedown="findGroupOrStudent"
                      v-bind:key="groupOrStudent.GroupName ? groupOrStudent.GroupName + groupOrStudent.GroupId : groupOrStudent.keyVal"
                    >
                      <span
                        class="name"
                        v-text="groupOrStudent.DisplayName"
                      ></span>
                      <span
                        v-if="groupOrStudent.FullName !== undefined"
                        class="typeAheadAddInfo"
                        v-text="` (${groupOrStudent.Group})`"
                      ></span>
                    </li>
                  </ul>
                </b-col>
              </b-row>
              <b-row
                v-if="selectedMunicipalityId !== null && searchData.length === 0 && loadingSearch === false"
                class="searchErrorRow"
              >
                <b-col class="error">{{translations.errors.searchError}}</b-col>
              </b-row>
              <!-- Groups Data -->
              <b-row v-if="foundGroup !== null">
                <b-col :class="[this.isClassFound ? 'classText' : '']">
                  <h5>{{translations.studentsFromClassText}} {{foundGroup.GroupName}}</h5>
                </b-col>
              </b-row>
              <b-row v-if="foundGroup !== null">
                <b-col id="classWrapper">
                  <b-list-group
                    v-for="(student, $student) in foundGroup.StudentDatas"
                    v-bind:key="student.AulaStudentId"
                    :class="setHoverStudentCssClass($student)"
                    @mousemove="setHoverStudent($student)"
                    @mouseout="resetHoverStudentCssClass"
                    @click="setActiveStudent($student, student)"
                  >
                    <b-list-group-item id="pupilItem" v-text="student.FullName"></b-list-group-item>
                  </b-list-group>
                  <div align="center" v-if="foundGroup.StudentDatas.length === 0">{{translations.noStudentsInGroupFound}}</div>
                </b-col>
              </b-row>
            </b-container>

            <!-- BASIC TABLES WRAPPER -->
            <b-container>
              <!-- Alias info -->
              <b-row v-if="foundPerson !== null && !!foundPerson.AliasFullName">
                <b-col>
                  <b-alert show variant="warning">
                    <p>{{translations.aliasText}}{{foundPerson.AliasFullName}}</p>
                  </b-alert>
                </b-col>
              </b-row>
              <!-- Student info -->
              <b-row v-if="foundPerson !== null">
                <b-col>
                  <h5>{{translations.pupilText}}</h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-table
                    v-if="foundPerson !== null"
                    striped
                    hover
                    :fields="personSearchFields"
                    :items="[foundPerson]"
                  ></b-table>
                </b-col>
              </b-row>
              <!-- MyRecent documents -->
              <b-row  v-if="currentMode === 'search' && !isClassWithoutCaseFound">
                <b-col>
                  <div class="labelWithSpinner">
                    <h5
                      :class="[!this.documentLoading ? 'showPointer' : '', this.isClassFound ? 'classText' : '']"
                      v-on="!this.documentLoading ? { click: () => this.refreshDocuments() } : {}"
                    >{{this.documentsHeader}}</h5>
                    <div
                      v-if="documentLoading && selectedMunicipalityId !== null"
                      class="recentDocumentInfo">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="selectedMunicipalityId !== null && isStudentOrClassFound && currentMode === 'search'">
                <!-- Document sort by property -->
                <b-col>
                  <b-form-select
                    v-if="loadingMyRecentDocuments || sortOptions.length === 0 || !anyDocumentsPresent"
                    disabled
                    v-model="selectedSortOption"
                    :options="sortOptions"
                  ></b-form-select>
                  <b-form-select v-else v-model="selectedSortOption" :options="sortOptions"></b-form-select>
                </b-col>
                <!-- Document filter by category -->
                <b-col>
                  <b-form-select
                    v-if="loadingMyRecentDocuments || documentFilterOptions.length === 0 || !anyDocumentsPresent"
                    disabled
                    v-model="documentFilterOption"
                    :options="documentFilterOptions"
                  ></b-form-select>
                  <b-form-select v-else v-model="documentFilterOption" :options="documentFilterOptions"></b-form-select>
                </b-col>
              </b-row>
              <!-- Document search -->
              <b-row v-if="selectedMunicipalityId !== null && isStudentOrClassFound && currentMode === 'search'">
                <b-container>
                  <b-row>
                    <b-col>
                      <div role="group" class="input-group search-input-group">
                        <b-form-input
                          type="text"
                          class="form-control"
                          id="documentSearchForm"
                          @keyup.enter="reloadDocuments(1)"
                          v-model="documentSearchPhrase"
                          :placeholder="translations.documentSearchPhrasePlaceholder"
                          :disabled="loadingMyRecentDocuments || !anyDocumentsPresent"
                          autocomplete="off"
                        ></b-form-input>
                        <span
                          v-show="selectedMunicipalityId !== null && searchData.length > 0"
                          class="icon-Aula_search"
                        ></span>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </b-row>
              <b-row v-if="recentDocumentsItems.length === 0 && currentMode === 'search'">
                <b-col align="center">
                  <div
                    v-if="selectedMunicipalityId === null"
                  >{{translations.errors.membershipNotPicked}}</div>
                  <b-spinner v-else-if="loadingMyRecentDocuments" class="align-middle"></b-spinner>
                  <h5 v-else-if="recentDocumentsFail" class="error">{{translations.errors.generic}}</h5>
                  <div v-else-if="recentDocumentsItems.length === 0">{{translations.noDocumentsFound}}</div>
                </b-col>
              </b-row>
              <b-row v-if="selectedMunicipalityId !== null && currentMode === 'search' && !isClassWithoutCaseFound">
                <b-col>
                  <b-table
                    v-if="recentDocumentsItems.length > 0"
                    striped
                    hover
                    :items="recentDocumentsItems"
                    :fields="recentDocumentsFields"
                    v-on:row-clicked="openLink"
                    :tbody-tr-class="recentDocumentsRowClass"
                  >
                    <template v-for="(field) in getEditableBoolRecentDocumentFields" v-slot:[`cell(${field.key})`]="data">
                      <div class="checkboxContainer" @click.stop="">
                        <b-form-checkbox
                          v-if="data.value != null && data.value !== ''"
                          :disabled="isRecentDocumentUpdatePropertyInProgress(data)"
                          switch
                          :checked = !!(+data.value)
                          @change="switchBoolDocumentProperty(data, $event)"
                          :class="isRecentDocumentUpdatePropertyInProgress(data) ? 'showNotAllowed' : ''"
                        >
                        </b-form-checkbox>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row
                v-if="selectedMunicipalityId !== null && isStudentOrClassFound && loadingMyRecentDocuments !== true && currentPage !== null && recentDocumentsItems.length !== 0 && recentDocumentsFail !== true && currentMode === 'search'"
              >
                <b-col align="left">
                  <i
                    v-if="currentPage !== null && currentPage !== 1"
                    :class="[this.documentLoading ? 'showNotAllowed' : 'showPointer']"
                    class="fas fa-arrow-alt-circle-left"
                    v-on="!this.documentLoading ? { click: () => reloadDocuments(currentPage-1) } : {}"
                  ></i>
                </b-col>
                <b-col align="center">{{currentPage}}</b-col>
                <b-col align="right">
                  <i
                    v-if="currentPage !== null && isPageLast !== true"
                    :class="[this.documentLoading ? 'showNotAllowed' : 'showPointer']"
                    class="fas fa-arrow-alt-circle-right"
                    v-on="!this.documentLoading ? { click: () => reloadDocuments(currentPage+1) } : {}"
                  ></i>
                </b-col>
              </b-row>
            </b-container>

            <!-- CREATE -->
            <b-container  v-if="currentMode === 'create'">
              <!-- Create title -->
              <b-row>
                <b-col class="text-center" :class="[this.isClassFound ? 'classText' : '']">
                  <h5>{{translations.createDocumentTitleText}}</h5>
                </b-col>
              </b-row>
              <!-- Success alert -->
              <b-row>
                <b-col>
                  <b-alert v-model="showSuccessAlert" variant="success" dismissible>
                    <p class="success">{{successAlertMessage}}</p>
                  </b-alert>
                </b-col>
              </b-row>
              <!-- Create picker title -->
              <b-row>
                <b-col>
                  <h5>
                    {{translations.selectedTemplateTypeText}}
                    <b-spinner v-if="loadingTemplates" class="align-middle"></b-spinner>
                  </h5>
                </b-col>
              </b-row>
              <!-- Template Type selection -->
              <b-row>
                <b-col>
                  <b-form-select
                    v-if="loadingTemplates || aulaTemplateTypes.length === 0"
                    disabled
                    v-model="selectedTemplateType"
                    :options="aulaTemplateTypes"
                  ></b-form-select>
                  <b-form-select v-else v-model="selectedTemplateType" :options="aulaTemplateTypes"></b-form-select>
                </b-col>
              </b-row>
              <b-row v-if="filteredDocumentTemplates.length > 0">
                <b-col>
                  <h5>
                    {{translations.documentTemplatesText}}
                  </h5>
                </b-col>
              </b-row>
              <b-row v-if="!loadingTemplates && aulaTemplateTypes.length === 0">
                <b-col class="error recentDocumentInfo inline text-center">
                  {{translations.errors.noTemplates}}
                </b-col>
              </b-row>
              <!-- Template selection -->
              <b-row v-if="filteredDocumentTemplates.length > 0">
                <b-col id="classWrapper">
                  <b-list-group
                    v-for="(template, $template) in filteredDocumentTemplates"
                    v-bind:key="template.Name"
                    :class="activeTemplateCssClass($template)"
                    @click="setActiveTemplate($template, template)"
                  >
                    <b-list-group-item id="pupilItem" v-text="template.Name"></b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
              <!-- Picking file name -->
              <b-row v-if="filteredDocumentTemplates.length > 0">
                <b-col>
                  <h5>
                    {{translations.fileNameText}}
                    <b-spinner
                      v-if="isCreationInProgress"
                      class="align-middle recentDocumentInfo inline"
                    ></b-spinner>
                    <div
                      v-if="isCreationSuccess === false"
                      class="recentDocumentInfo inline error"
                    >{{translations.errors.generic}}</div>
                    <div
                      v-if="isCreationSuccess === true"
                      class="recentDocumentInfo inline success"
                    >{{translations.creationSuccess}}</div>
                  </h5>
                </b-col>
              </b-row>
              <b-row v-if="filteredDocumentTemplates.length > 0">
                <b-col>
                  <b-form-input v-if="pickedDocumentTemplate === null" disabled></b-form-input>
                  <b-form-input
                    v-else
                    v-model="createDocumentNewTitle"
                    @keypress.enter="saveTemplateDocument"
                    @input="onChangeDocumentName"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row v-if="this.documentNameContainsIllegalCharacter">
                <b-col>
                  <div class="recentDocumentInfo error illegalCharactersInfo">
                    {{translations.errors.nameContainsIllegalCharacters}}
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="this.documentNameIsTooLong">
                <b-col>
                  <div class="recentDocumentInfo error illegalCharactersInfo">
                    {{translations.errors.documentNameIsTooLong}}
                  </div>
                </b-col>
              </b-row>
              <div v-if="filteredDocumentTemplates.length > 0
                  && getEditableBoolRecentDocumentFields != null
                  && getEditableBoolRecentDocumentFields.length > 0">
                <b-row>
                  <b-col>
                    <h5>
                      {{translations.documentPropertiesText}}
                    </h5>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-table
                      :fields="createUploadDocumentPropertiesFields"
                      :items="getEditableBoolRecentDocumentFields"
                      thead-class="hideHeader"
                      tbody-tr-class="disablePointerEvents"
                    >
                      <template v-slot:cell(Value)="{ item }">
                        <div class="checkboxContainer">
                          <b-form-checkbox
                            switch
                            :checked = false
                            @change="setNewValueForRecentDocumentField(item, $event)"
                          >
                          </b-form-checkbox>
                        </div>
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
              </div>
              <!-- Buttons -->
              <b-row align-h="around">
                <!-- Save and open -->
                <b-col cols="4" align="center">
                  <b-button
                    variant="primary"
                    v-if="pickedDocumentTemplate === null
                      || isCreationInProgress
                      || currentTemplateIndex === -1
                      || isCreationSuccess
                      || documentNameContainsIllegalCharacter
                      || documentNameIsTooLong"
                    disabled
                  >{{translations.saveAndOpenButtonText}}</b-button>
                  <b-button
                    variant="primary"
                    v-else
                    @click="saveTemplateDocument"
                    @keyup.enter="saveTemplateDocument"
                  >{{translations.saveAndOpenButtonText}}</b-button>
                </b-col>
                <!-- Go back to search -->
                <b-col cols="4" align="center">
                  <b-button
                    variant="secondary"
                    @click="goBackToSearch(true)"
                  >{{translations.goBackButtonText}}</b-button>
                </b-col>
              </b-row>
            </b-container>

            <!-- UPLOAD -->
            <b-container v-if="currentMode === 'upload'">
              <!-- Upload title -->
              <b-row>
                <b-col class="text-center" :class="[this.isClassFound ? 'classText' : '']">
                  <h5>{{translations.openUploadDocumentModeText}}</h5>
                </b-col>
              </b-row>
              <!-- Upload zone -->
              <b-row>
                <b-col>
                  <div>
                    <b-form-file
                      v-if="loadingTemplates || aulaTemplateTypes.length === 0"
                      disabled
                      v-model="file"
                      :state="Boolean(file)"
                      :placeholder="translations.uploadPlaceholderText"
                      :drop-placeholder="translations.uploadDropPlaceholderText"
                      browse-text="Gennemse"
                      @input="setUploadedDocumentName"
                    ></b-form-file>
                    <b-form-file
                      v-else
                      v-model="file"
                      :state="Boolean(file)"
                      :placeholder="translations.uploadPlaceholderText"
                      :drop-placeholder="translations.uploadDropPlaceholderText"
                      browse-text="Gennemse"
                      @input="setUploadedDocumentName"
                    ></b-form-file>
                  </div>
                </b-col>
              </b-row>
              <!-- File info -->
              <b-row>
                <b-col>
                  <div class="mt-3 bold">{{translations.selectedFileText}}</div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div>{{ file ? file.name : translations.noFileSelectedText }}</div>
                </b-col>
              </b-row>
              <!-- Document type selection -->
              <b-row>
                <b-col>
                  <div class="mt-3 bold">
                    <div class="inline">{{translations.selectedTemplateTypeText}}</div>
                    <div v-if="loadingTemplates" class="align-middle recentDocumentInfo inline">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                    <div
                      v-if="!loadingTemplates && aulaTemplateTypes.length === 0"
                      class="error recentDocumentInfo inline"
                    >{{translations.errors.noTemplates}}</div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-select
                    v-if="file === null || loadingTemplates || aulaTemplateTypes.length === 0"
                    disabled
                    v-model="selectedTemplateType"
                    :options="aulaTemplateTypes"
                  ></b-form-select>
                  <b-form-select v-else v-model="selectedTemplateType" :options="aulaTemplateTypes" @input="onChangeDocumentName"></b-form-select>
                </b-col>
              </b-row>
              <!-- Picking file name -->
              <b-row>
                <b-col>
                  <h5>
                    {{translations.fileNameText}}
                    <b-spinner v-if="isUploadInProgress" class="align-middle recentDocumentInfo inline"></b-spinner>
                    <div
                      v-if="isUploadSuccess === false"
                      class="recentDocumentInfo inline error"
                    >{{translations.uploadFail}}</div>
                    <div
                      v-if="isUploadSuccess === true"
                      class="recentDocumentInfo inline success"
                    >{{translations.uploadSuccess}}</div>
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-input v-if="file === null" disabled></b-form-input>
                  <b-form-input v-else v-model="createDocumentNewTitle" @input="onChangeDocumentName"></b-form-input>
                </b-col>
              </b-row>
              <b-row v-if="this.documentNameContainsIllegalCharacter">
                <b-col>
                  <div class="recentDocumentInfo error illegalCharactersInfo">
                    {{translations.errors.nameContainsIllegalCharacters}}
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="this.documentNameIsTooLong">
                <b-col>
                  <div class="recentDocumentInfo error illegalCharactersInfo">
                    {{translations.errors.documentNameIsTooLong}}
                  </div>
                </b-col>
              </b-row>
              <!-- Editable fields -->
              <div v-if="getEditableBoolRecentDocumentFields != null && getEditableBoolRecentDocumentFields.length > 0">
                <b-row>
                  <b-col>
                    <h5>
                      {{translations.documentPropertiesText}}
                    </h5>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-table
                      :fields="createUploadDocumentPropertiesFields"
                      :items="getEditableBoolRecentDocumentFields"
                      thead-class="hideHeader"
                      tbody-tr-class="disablePointerEvents"
                    >
                      <template v-slot:cell(Value)="{ item }">
                        <div class="checkboxContainer">
                          <b-form-checkbox
                            switch
                            :checked = false
                            @change="setNewValueForRecentDocumentField(item, $event)"
                          >
                          </b-form-checkbox>
                        </div>
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
              </div>
              <!-- Buttons -->
              <b-row align-h="around">
                <!-- Save -->
                <b-col cols="4" align="center">
                  <b-button
                    variant="primary"
                    v-if="file === null
                      || isUploadInProgress
                      || !aulaTemplateTypes
                      || selectedTemplateType === null
                      || isUploadSuccess
                      || documentNameContainsIllegalCharacter
                      || documentNameIsTooLong"
                    disabled
                  >{{translations.saveButtonText}}</b-button>
                  <b-button
                    variant="primary"
                    v-else
                    @click="uploadDocument"
                    @keyup.enter="uploadDocument"
                  >{{translations.saveButtonText}}</b-button>
                </b-col>
                <!-- Go back to search -->
                <b-col cols="4" align="center">
                  <b-button
                    variant="secondary"
                    @click="goBackToSearch(true)"
                  >{{translations.goBackButtonText}}</b-button>
                </b-col>
              </b-row>
            </b-container>

            <!-- FUNCTION BUTTONS WRAPPER -->
            <b-container v-if="currentMode === 'search'">
              <b-row align-h="around">
                <b-col cols="4" align="center" ref="createDocumentRef">
                  <b-button
                    variant="primary"
                    v-if="this.isStudentOrClassFound"
                    v-on:click="createDocument"
                  >{{translations.createDocumentButtonText}}</b-button>
                  <b-button v-else variant="primary" disabled>{{translations.createDocumentButtonText}}</b-button>
                </b-col>
                <b-col cols="4" align="center">
                  <b-button
                    variant="primary"
                    v-if="this.isStudentOrClassFound"
                    v-on:click="openUploadDocumentMode"
                  >{{translations.openUploadDocumentModeButtonText}}</b-button>
                  <b-button
                    v-else
                    variant="primary"
                    disabled
                  >{{translations.openUploadDocumentModeButtonText}}</b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "go-aula-connector",
  props: {
    axios: Function,
    moment: Function,
    sessionUUID: String,
    placement: String,
    isMobileApp: Boolean,
    getAulaToken: Function,
    assuranceLevel: Number,
    userProfile: String,
    triggerStepUp: Function
  },
  data() {
    return {
      //translations
      translations: {
        widgetTitle: "Digitale mapper",
        searchTitle: "Søg",
        myRecentDocumentsTitle: "Mine seneste dokumenter",
        createDocumentButtonText: "OPRET DOKUMENT",
        createDocumentTitleText: "Opret dokument",
        openUploadDocumentModeButtonText: "UPLOAD DOKUMENT",
        findPupilOrClassText: "Find elev eller klasse",
        refreshWidgetText: "Klik for at opdatere",
        studentsFromClassText: "Klasse: ",
        documentsFromClassText: "Dokumenter fra klasse: ",
        fileNameText: "Vælg navn:",
        documentPropertiesText: "Dokumentegenskaber:",
        saveAndOpenButtonText: "GEM OG ÅBN",
        saveButtonText: "GEM",
        goBackButtonText: "GÅ TILBAGE",
        pupilText: "Elev",
        documentTemplatesText: "Dokument skabeloner",
        openUploadDocumentModeText: "Upload dokument",
        uploadPlaceholderText: "Vælg en fil, eller slip den her...",
        uploadDropPlaceholderText: "Slip fil her...",
        selectedFileText: "Valgt fil:",
        selectedTemplateTypeText: "Vælg undermappe:",
        noFileSelectedText: "Ingen fil valgt",
        loadingText: "Indlæser ",
        pickMunicipalityText: "Vælg kommune",
        documentIsStreaming: "Dokumentet er under behandling...",
        errors: {
          generic: "Fejl",
          general:
            "Der skete en fejl under behandlingen af forespørgelsen. Prøv igen. Hvis fejlen bliver ved med at optræde så kontakt administrator.",
          documentSync:
            "Handlingen kan ikke udføres på dokumenter, der er tjekket ud.",
          membershipError:
            "Du er ikke tilmeldt nogen grupper i kommunens institutioner.",
          membershipNotPicked: "Vælg kommune",
          searchError:
            "Der skete en fejl under behandlingen af forespørgelsen. Hvis fejlen bliver ved med at optræde så kontakt administrator.",
          noTemplates: "Ingen skabeloner fundet",
          noOneDriveAccount: "OneDrive konto ikke fundet for din bruger",
          studentWithoutCase:
            "Denne person har ikke en tilsvarende mappe i GO. Kontakt systemadministrator.",
          noSubcasesPresent:
            "Personen har ingen undermapper i sagssystemet. Kontakt systemadministrator.",
          noMatchingSubcase:
            "Der kunne ikke findes en undermappe som passer til på denne person. Kontakt systemadministrator.",
          nameContainsIllegalCharacters:
            "Dokumentnavnet indeholder mellemrum eller ugyldige karakterer: \\/#%&*?{}:\"<>|",
          updateDocumentPropertiesDocumentCheckedOut:
            " kan ikke opdateres, fordi dokumentet er tjekket ud. Prøv venligst igen senere.",
          updateDocumentPropertiesGeneralError:
            " kan ikke opdateres. Kontakt venligst administratoren.",
          updateDocumentPropertiesFieldDoesNotExist:
            " kan ikke opdateres, fordi feltet ikke findes i GetOrganized systemet. Kontakt venligst administratoren.",
          updateDocumentPropertiesDocumentFinalized:
            " kan ikke opdateres, da dokumentet er endeliggjort.",
          documentNameIsTooLong: "Dokumentnavnet er for langt",
        },
        successes: {
          documentCreationSuccess: "Bare rolig, dit dokument er oprettet og gemt. Der kan gå op til flere minutter før, at du kan se dokumentet."
        },
        noDocumentsFound: "Ingen dokumenter fundet",
        noStudentsInGroupFound: "Ingen elever fundet i klasse",
        uploadSuccess: "Dokument uploaded med succes",
        uploadFail: "Upload af dokument fejlet",
        creationSuccess: "Dokument oprettet",
        noSorting: "Ingen sortering",
        noFiltering: "Ingen filtrering",
        documentSearchPhrasePlaceholder: "Find dokumenter",
        documentUploadTimeout: "Dette tager længere tid end forventet. Dokumentet bliver uploadet i baggrunden. Venligst check igen om et par minutter.",
        aliasText: "Barnet har navne- og adressebeskyttelse. Alias er ",
        assuranceLevelWarningText: "Du er ikke logget ind med et højt nok sikkerhedsniveau for at få adgang til denne widget. Klik på knappen nedenunder for at logge ind med forhøjet sikkerhed.",
        assuranceLevelLoginButtonText: "Log ind med forhøjet sikkerhed",
        serviceWindowMessage: "Vedligehold i gang"
      },
      azureFunctionAppHostUrl: "https://aulaconnectorapi.azurewebsites.net",
      //multi-tenancy
      municipalities: [],
      isServiceMode: false,
      selectedMunicipalityId: null,
      municipalityLocalStorage: null,
      //students handling
      searchData: [],
      foundPerson: null,
      filteredStudents: [],
      current: -1,
      hoverStudentIndex: -1,
      hoverStudent: false,
      //Documents lists
      documentsHeader: "",
      recentDocumentsItems: [],
      recentDocumentsFields: [],
      recentDocumentUpdatePropertyInProgress: [],
      createUploadDocumentPropertiesFields: [
        {key:"label", tdClass:"smallCellTable"},
        {key:"Value", tdClass:"smallCellTable"}
      ],
      anyDocumentsPresent: false,
      initialRecentDocumentsItems: [],
      loadingMyRecentDocuments: false,
      recentDocumentsFail: false,
      isPageLast: null,
      currentPage: null,
      sortOptions: [],
      selectedSortOption: null,
      sortColumn: null,
      sortMode: null,
      errorAlertMessage: null,
      showErrorAlert: false,
      successAlertMessage: null,
      showSuccessAlert: false,
      documentFilterOptions: [],
      documentFilterOption: null,
      documentSearchPhrase: null,
      documentNameContainsIllegalCharacter: false,
      documentNameIsTooLong: false,
      //search
      personSearchFields: [
        {
          key: "name",
          label: "Navn",
          formatter: (value, key, item) => {
            return item.FullName;
          },
        },
        {
          key: "group",
          label: "Klasse",
          formatter: (value, key, item) => {
            return item.Group;
          },
        },
        {
          key: "cpr",
          label: "CPR",
          formatter: (value, key, item) => {
            return item.CPR;
          },
        },
      ],
      searchStatus: null,
      searchTerm: "",
      filteredSearchItems: [],
      foundGroup: null,
      currentMode: "search", //also create and upload,
      loadingSearch: false,
      //template and upload handling
      aulaTemplateTypes: [],
      file: null,
      selectedTemplateType: null,
      pickedDocumentTemplate: null,
      currentTemplateIndex: -1,
      createDocumentNewTitle: "",
      loadingTemplates: false,
      isUploadInProgress: false,
      isUploadSuccess: null,
      isCreationInProgress: null,
      isCreationSuccess: null,
      //security
      aulaToken: undefined,
      documentLoading: false,
      aulaErrorCodes: null,
      checkAssuranceLevel: false,
      //consts
      consts: {
        DOCUMENTUPLOAD_MAX_TIMEOUT: 180000, // 3min in ms
        MUNICIPALITY_LOCAL_STORAGE_NAME: "CCMMunicipalityId",
        DOC_LOADING_FIELD_NAME: 'IsLoading',
        ILLEGAL_CHARACTERS_REGEX: /[\x07\b\t\n\v\f\r\u0001\u0002\u0003\u0004\u0005\u0006\u000E\u000F\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001A\u001B\u001C\u001D\u001E\u001F\\#%&*?/{}:"<>|]/
      }
    };
  },
  methods: {
    getNewDocumentProperties: function() {
      let newDocumentProperties = [];
      let boolDocumentProperties = this.getEditableBoolRecentDocumentFields;

      if(boolDocumentProperties == null || boolDocumentProperties.length === 0) {
        return newDocumentProperties;
      }

      boolDocumentProperties.forEach((prop) => {
        newDocumentProperties.push({InternalName: prop.key, Value: prop.NewValue ? "1" : "0"})
      })

      return newDocumentProperties
    },
    setNewValueForRecentDocumentField(item, newValue) {
      item.NewValue = newValue;
    },
    isRecentDocumentUpdatePropertyInProgress: function(data) {
      if (data === null || data.index === null || data.item === null || data.field?.key === null) return false;
      if (data.item[this.consts.DOC_LOADING_FIELD_NAME]) return true;

      return this.recentDocumentUpdatePropertyInProgress?.filter((x) => x.Index === data.index && x.InternalName === data.field.key).length > 0
    },
    switchBoolDocumentProperty(data, newValue) {
      this.updateDocumentProperty(data.index, data.item?.DocumentId, data.field?.key, data.field?.label, this.parseBoolToString(newValue))
    },
    parseBoolToString: function (value) {
      return +value + ""
    },
    recentDocumentsRowClass(item, type) {
      return item &&
      type === 'row' &&
      item[this.consts.DOC_LOADING_FIELD_NAME]
        ? 'recentDocumentsRowInactive'
        : null;
    },
    updateRecentDocumentItem(value, index, key) {
      this.recentDocumentsItems[index][key] = value;
      this.$set(this.recentDocumentsItems, index, this.recentDocumentsItems[index]);
    },
    showCustomSuccessMessage: function (message) {
      this.successAlertMessage = message;
      this.showSuccessAlert = true;
    },
    showErrorMessage: function (errorCode, arg) {
      if (!this.aulaErrorCodes) {
        this.aulaErrorCodes = {
          AULA_CONNECTOR_ERROR_1000: this.translations.errors.general,
          AULA_CONNECTOR_ERROR_1001: this.translations.errors.documentSync,
          AULA_CONNECTOR_ERROR_1002: this.translations.errors.studentWithoutCase,
          AULA_CONNECTOR_ERROR_1003: this.translations.errors.noSubcasesPresent,
          AULA_CONNECTOR_ERROR_1004: this.translations.errors.noMatchingSubcase,
          AULA_CONNECTOR_ERROR_1005: this.translations.errors.nameContainsIllegalCharacters,
          AULA_CONNECTOR_ERROR_1006: this.translations.errors.updateDocumentPropertiesDocumentCheckedOut,
          AULA_CONNECTOR_ERROR_1007: this.translations.errors.updateDocumentPropertiesGeneralError,
          AULA_CONNECTOR_ERROR_1008: this.translations.errors.updateDocumentPropertiesFieldDoesNotExist,
          AULA_CONNECTOR_ERROR_1009: this.translations.errors.updateDocumentPropertiesDocumentFinalized,
        };
      }

      switch(errorCode) {
        case "AULA_CONNECTOR_ERROR_1006":
        case "AULA_CONNECTOR_ERROR_1007":
        case "AULA_CONNECTOR_ERROR_1008":
        case "AULA_CONNECTOR_ERROR_1009":
          if(arg) {
            this.errorAlertMessage = arg + this.aulaErrorCodes[errorCode];
          }
          break;
        default:
          this.errorAlertMessage = this.aulaErrorCodes[errorCode];
          break;
      }

      if (!this.errorAlertMessage || !errorCode) {
        this.errorAlertMessage = this.translations.errors.general;
      }

      this.showErrorAlert = true;
    },
    showCustomErrorMessage: function (message) {
      this.errorAlertMessage = message;
      this.showErrorAlert = true;
    },
    getMembership: function () {
      let municipalities = [];
      municipalities.push({
        value: null,
        text: this.translations.pickMunicipalityText,
        isOneDriveAccountSet: true,
        shouldCheckAssuranceLevel: false
      });

      try {
        this.axios
          .get(
            this.azureFunctionAppHostUrl + "/api/Membership",
            this.getHeaders()
          )
          .then((response) => {
            if (!response.data || !response.data.Membership) {
              this.municipalities = municipalities;
            }

            this.isServiceMode = !!response && !!response.data && !!response.data.IsServiceMode;

            let membership = response.data.Membership;
            for (let i = 0; i < membership.length; i++) {
              let municipality = membership[i];
              municipalities.push({
                value: municipality.AulaMunicipalityId,
                text: municipality.AulaMunicipalityName,
                isOneDriveAccountSet: municipality.IsOneDriveAccountSet,
                shouldCheckAssuranceLevel: municipality.ShouldCheckAssuranceLevel
              });
            }

            this.municipalities = municipalities;

            if(!this.municipalityLocalStorage){
              this.municipalityLocalStorage = this.getMunicipalityLocalStorageValue();
            }

            if(this.selectedMunicipalityId !== this.municipalityLocalStorage) {
              this.selectedMunicipalityId = this.municipalityLocalStorage;
            }
          })
          .catch((error) => {
            console.log(error);
            this.municipalities = municipalities;
          });
      } catch (error) {
        console.log(error);
        this.municipalities = municipalities;
      }
    },
    loadSearchData: function () {
      try {
        let request = { AulaMunicipalityId: this.selectedMunicipalityId };

        let groups = [];

        this.loadingSearch = true;
        this.axios
          .post(
            this.azureFunctionAppHostUrl + "/api/GroupsData",
            request,
            this.getHeaders()
          )
          .then((response) => {
            groups = response.data ? response.data.GroupsDatas : [];
            groups.forEach((group) => {
              group.DisplayName = group.GroupName;
              group.StudentDatas = group.StudentDatas?.sort((a, b) => (a.FullName > b.FullName ? 1 : -1));
            });

            this.loadingSearch = false;
            this.searchData = groups;
          })
          .catch((error) => {
            this.loadingSearch = false;
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    findGroupOrStudent: function (event) {
      if(this.currentMode === "create" || this.currentMode === "upload"){
        this.aulaTemplateTypes = [];
        this.loadingTemplates = true;
        this.showSuccessAlert = false;
        this.currentMode = "search";
      }
      if (this.filteredSearchItems.length > 0 && this.current !== -1) {
        let searchedItem = this.filteredSearchItems[this.current];
        if (!!searchedItem.FullName) this.handleStudentFound(searchedItem);
        if (!!searchedItem.GroupName) this.handleGroupFound(searchedItem);
        this.searchStatus = true;
      } else {
        this.searchStatus = false;
      }
      this.filteredSearchItems = [];
      this.current = -1;
    },
    createDocument: function () {
      this.currentMode = "create";
      this.getTemplates();
    },
    openUploadDocumentMode: function () {
      this.currentMode = "upload";
      this.getTemplates();
    },
    uploadDocument: function () {
      try {
        if (this.file === null) return;
        this.isUploadSuccess = null;
        this.showSuccessAlert = false;

        let fileExtension = this.file.name.substr(
          this.file.name.lastIndexOf(".")
        );
        let documentTitle = !this.createDocumentNewTitle
          ? this.file.name
          : this.createDocumentNewTitle;

        this.createDocumentNewTitle = documentTitle = this.ensureExtension(
          fileExtension,
          documentTitle.trim()
        );

        let fileReader = new FileReader();

        fileReader.onloadend = () => {
          //prune the leading  "data: ..;base64,"
          let fileBase64 = fileReader.result.split(",")[1];
          let request = {
            AulaId: this.getAulaIdFromContext,
            DocumentType: this.getDocumentTypeFromContext,
            AulaTemplateType: this.selectedTemplateType,
            DocumentBinary: fileBase64,
            DocumentTitle: documentTitle,
            AulaMunicipalityId: this.selectedMunicipalityId,
            DocumentProperties: this.getNewDocumentProperties()
          };

          this.isUploadInProgress = true;

          let options = {...this.getHeaders(), "timeout": this.consts.DOCUMENTUPLOAD_MAX_TIMEOUT};
          this.axios
            .post(
              this.azureFunctionAppHostUrl + "/api/DocumentUpload",
              request,
              options
            )
            .then((response) => {
              if (
                response &&
                response.data &&
                response.data.Message &&
                !response.data.Success
              ) {
                this.isUploadSuccess = false;
                this.showErrorMessage(response.data.Message);
              } else {
                this.showCustomSuccessMessage(this.translations.successes.documentCreationSuccess);
                this.isUploadSuccess = true;
              }

              this.isUploadInProgress = false;
            })
            .catch((error) => {
              this.isUploadSuccess = false;
              this.isUploadInProgress = false;
              console.log(error);
              error.code == 'ECONNABORTED' ? // Connection timeout error
                this.showCustomErrorMessage(this.translations.documentUploadTimeout) :
                this.showErrorMessage(error.headers.errorcode);
            });
        };

        fileReader.readAsDataURL(this.file);
      } catch (error) {
        if (this.isUploadSuccess !== null) this.isUploadSuccess = false;
        this.isUploadInProgress = false;
        console.log(error);
      }
    },
    setActiveCssClass: function setActiveCssClass(index) {
      return {
        active: this.current === index,
      };
    },
    setActive: function setActive(index) {
      this.current = index;
    },
    getStudentsAndGroups: function getStudentsAndGroups() {
      let loweredSearchTerm = this.searchTerm.toLowerCase();
      if (this.searchTerm.length < 2) {
        this.filteredSearchItems = [];
        return;
      }

      this.filteredStudents = this.allStudents.filter((student) => {
        let fullName = student.FullName;
        let mainGroupName = this.groupNamesDictionary[student.MainGroupID];

        if (
          fullName.toLowerCase().indexOf(loweredSearchTerm) !== -1 &&
          (!mainGroupName || mainGroupName === student.Group)
        )
          return student;
      });

      this.filteredGroups = this.searchData.filter((cl) => {
        if (cl.GroupName.toLowerCase().indexOf(loweredSearchTerm) !== -1)
          return cl;
      });

      this.filteredSearchItems = [
        ...this.filteredStudents,
        ...this.filteredGroups,
      ].sort((a, b) => (a.DisplayName > b.DisplayName ? 1 : -1));
    },
    up: function up() {
      if (this.current > 0) {
        this.current--;
      } else if (this.current === -1) {
        this.current = this.filteredSearchItems.length - 1;
      } else {
        this.current = -1;
      }
    },
    down: function down() {
      if (this.current < this.filteredSearchItems.length - 1) {
        this.current++;
      } else {
        this.current = -1;
      }
    },
    handleStudentFound: function handleStudentFound(student) {
      this.foundGroup = null;

      this.searchTerm = student.FullName;

      let mainGroupName = this.groupNamesDictionary[student.MainGroupID];
      let groupName = !mainGroupName ? student.Group : mainGroupName;

      this.foundPerson = {
        FullName: student.FullName,
        CPR: student.CPR,
        Group: groupName,
        AulaStudentId: student.AulaStudentId,
        InstitutionNumber: student.InstitutionNumber,
        AliasFullName: student.AliasFullName
      };

      this.clearSortFilterSearch();

      //get placeholders for sort and filter
      this.getSortOptions();
      this.getDocumentFilterOptions();

      this.getTemplates();

      this.documentsHeader = student.FullName + "s dokumenter";

      this.anyDocumentsPresent = false;
      this.loadDocuments();
    },
    handleGroupFound: function handleGroupFound(groupData) {
      this.foundGroup = {
        StudentDatas: groupData.StudentDatas,
        GroupId: groupData.GroupId,
        GroupName: groupData.GroupName,
        HasAulaClassCase: groupData.HasAulaClassCase,
        InstitutionNumber: groupData.InstitutionNumber
      };

      this.searchTerm = this.foundGroup.GroupName;
      this.foundPerson = null;

      if (!this.foundGroup.HasAulaClassCase) {
        return;
      }

      this.clearSortFilterSearch();

      //get placeholders for sort and filter
      this.getSortOptions();
      this.getDocumentFilterOptions();

      this.getTemplates();

      this.documentsHeader = this.translations.documentsFromClassText + groupData.GroupName;

      this.anyDocumentsPresent = false;
      this.loadDocuments();
    },
    handleSearchFocusOut: function handleSearchFocusOut() {
      this.filteredSearchItems = [];
      this.current = -1;
      this.searchStatus = null;
    },
    setHoverStudentCssClass: function setHoverStudentCssClass(index) {
      return { hoverStudent: this.hoverStudentIndex === index };
    },
    resetHoverStudentCssClass: function resetHoverStudentCssClass() {
      this.hoverStudentIndex = -1;
    },
    setActiveStudent: function setActiveStudent(index, student) {
      if(this.currentMode === "create" || this.currentMode === "upload"){
        this.aulaTemplateTypes = [];
        this.loadingTemplates = true;
        this.showSuccessAlert = false;
        this.currentMode = "search";
      }
      this.hoverStudent = false;
      this.hoverStudentIndex = -1;
      this.handleStudentFound(student);
    },
    setHoverStudent: function setHoverStudent(index) {
      this.hoverStudent = true;
      this.hoverStudentIndex = index;
    },
    goBackToSearch: function goBackToSearch(shouldReloadDocuments) {
      this.currentMode = "search";
      this.createDocumentNewTitle = "";
      this.file = null;
      this.showSuccessAlert = false;

      if(shouldReloadDocuments){
        this.reloadDocuments(1);
      }

      this.currentTemplateIndex = -1;
      this.pickedDocumentTemplate = null;
      this.createDocumentNewTitle = "";
      this.isUploadSuccess = null;
      this.isCreationSuccess = null;
      this.selectedTemplateType =
        this.aulaTemplateTypes.length > 0
          ? this.aulaTemplateTypes[0].value
          : null;
    },
    activeTemplateCssClass: function activeTemplateCssClass(index) {
      return {
        activePupil: this.currentTemplateIndex === index,
      };
    },
    setActiveTemplate: function setActiveTemplate(index, template) {
      this.isCreationSuccess = null;
      this.currentTemplateIndex = index;
      this.pickedDocumentTemplate = template;
      this.createDocumentNewTitle = this.ensureExtension(
        template.Extension,
        template.Name
      );
    },
    saveTemplateDocument: function saveTemplateDocument(template) {
      try {
        this.isCreationSuccess = null;
        this.showSuccessAlert = false;
        let documentTitle = !this.createDocumentNewTitle
          ? this.pickedDocumentTemplate.Name
          : this.createDocumentNewTitle;

        this.createDocumentNewTitle = documentTitle = this.ensureExtension(
          this.pickedDocumentTemplate.Extension,
          documentTitle.trim()
        );

        let request = {
          AulaId: this.getAulaIdFromContext,
          DocumentType: this.getDocumentTypeFromContext,
          TemplateId: this.pickedDocumentTemplate.TemplateId,
          DocumentTitle: documentTitle,
          AulaMunicipalityId: this.selectedMunicipalityId,
          DocumentProperties: this.getNewDocumentProperties()
        };
        this.isCreationInProgress = true;

        var documentWindow = this.openDocumentOpeningWindow();

        this.axios
          .post(
            this.azureFunctionAppHostUrl + "/api/DocumentCreate",
            request,
            this.getHeaders()
          )
          .then((response) => {
            if (!response.data || !response.data.Url) {
              documentWindow.close();
              this.handleSaveTemplateResponse(false);
            }

            if (this.currentMode === "create")
              documentWindow.location = response.data.Url;

            this.handleSaveTemplateResponse(true);
            this.showCustomSuccessMessage(this.translations.successes.documentCreationSuccess);
          })
          .catch((error) => {
            documentWindow.close();
            this.handleSaveTemplateResponse(false);
            console.log(error);
            this.showErrorMessage(error.headers.errorcode);
          });
      } catch (error) {
        console.log(error);
        this.isCreationInProgress = false;
      }
    },
    handleSaveTemplateResponse: function (isSuccess) {
      this.isCreationSuccess = isSuccess;
      this.isCreationInProgress = false;
    },
    ensureExtension: function (extension, title) {
      return title.endsWith(extension) ? title : title + extension;
    },
    refreshWidget: function refreshWidget() {
      this.current = -1;
      this.currentTemplateIndex = -1;
      this.hoverStudentIndex = -1;
      this.documentsHeader = this.translations.myRecentDocumentsTitle;

      this.file = null;

      this.recentDocumentsFields = [];
      this.recentDocumentsItems = [];

      if (this.selectedMunicipalityId !== null && !!this.isUserAllowedToGetData) this.loadMyRecentDocuments();

      this.aulaTemplateTypes = [];

      this.searchStatus = null;
      this.foundPerson = null;
      this.foundGroup = null;
      this.searchTerm = "";
      this.currentMode = "search";
      this.isPageLast = null;
      this.currentPage = null;
      this.sortOptions = [];
      this.isUploadSuccess = null;
      this.isCreationSuccess = null;
    },
    openLink: function openLink(item, index, event) {
      if(item[this.consts.DOC_LOADING_FIELD_NAME]) {
        return;
      }

      this.documentLoading = true;
      this.updateRecentDocumentItem(true, index, this.consts.DOC_LOADING_FIELD_NAME);
      let request = {
        AulaMunicipalityId: this.selectedMunicipalityId,
        DocumentId: item.DocumentId,
      };

      var documentWindow = this.openDocumentOpeningWindow();

      this.axios
        .post(
          this.azureFunctionAppHostUrl + "/api/DocumentOpen",
          request,
          this.getHeaders()
        )
        .then((response) => {
          if (!response.data || !response.data.Link) {
            documentWindow.close();
            this.showErrorMessage();
          }
          documentWindow.location = response.data.Link;
          this.updateRecentDocumentItem(false, index, this.consts.DOC_LOADING_FIELD_NAME);
        })
        .catch((e) => {
          documentWindow.close();
          this.updateRecentDocumentItem(false, index, this.consts.DOC_LOADING_FIELD_NAME);
          this.showErrorMessage(e.headers.errorcode);
          console.log(e);
        });
    },
    openDocumentOpeningWindow: function openDocumentOpeningWindow() {
      var newWindow = window.open("", "_blank");
      var base64spinner =
        "data:image/gif;base64,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";
      var styleSheet = newWindow.document.createElement("style");
      styleSheet.innerHTML =
        "body{font-family:'Lato',sans-serif;color:#222350;background-color:#f6f7f8}div.doc-streaming-containter{padding-top:5%}.doc-streaming-containter h1{text-align:center}.doc-streaming-containter img{top:50px;left:0;margin-left:auto;margin-right:auto;right:0;border:0;display:block}";
      newWindow.document.body.innerHTML =
        "<div class='doc-streaming-containter'><h1>" +
        this.translations.documentIsStreaming +
        "</h1><img src='" +
        base64spinner +
        "' /></div>";
      newWindow.document.body.appendChild(styleSheet);
      return newWindow;
    },
    setUploadedDocumentName: function setUploadedDocumentName(file) {
      this.createDocumentNewTitle = file.name;
    },
    onChangeDocumentName: function changeUploadedDocumentName(){
      this.isCreationSuccess = null;
      this.isUploadSuccess = null;
    },
    createDocumentTypeChanged: function createDocumentTypeChanged() {
      this.currentTemplateIndex = -1;
      this.pickedDocumentTemplate = null;
    },
    loadMyRecentDocuments: function loadMyRecentDocuments() {
      try {
        if(this.isServiceMode){
          this.recentDocumentsFail = true;
          this.loadingMyRecentDocuments = false;
          return;
        }

        this.loadingMyRecentDocuments = true;
        this.recentDocumentsFail = false;
        this.recentDocumentsItems = [];
        this.recentDocumentsFields = [];

        let request = {
          AulaMunicipalityId: this.selectedMunicipalityId,
        };

        this.axios
          .post(
            this.azureFunctionAppHostUrl + "/api/DocumentsMy",
            request,
            this.getHeaders()
          )
          .then((response) => {
            if (!response || !response.data) {
              this.loadingMyRecentDocuments = false;
              return;
            }

            let requestMunicipalityId = response.data.AulaMunicipalityId;
            let documentDatas = response.data.DocumentData;

            if (
              requestMunicipalityId !== this.selectedMunicipalityId ||
              this.recentDocumentsItems.length > 0 ||
              this.currentPage !== null
            )
              return;

            if (!documentDatas) {
              this.recentDocumentsFail = true;
              this.loadingMyRecentDocuments = false;
              return;
            }

            let recentDocuments = [];
            for (let index = 0; index < documentDatas.length; index++) {
              let doc = documentDatas[index];

              let recentDocument = this.buildMyRecentDocument(doc);
              if (recentDocument !== null) recentDocuments.push(recentDocument);
            }
            if (!!recentDocuments) this.recentDocumentsItems = recentDocuments;
            this.initialRecentDocumentsItems = this.recentDocumentsItems;
            this.loadingMyRecentDocuments = false;
          })
          .catch((error) => {
            this.recentDocumentsItems = [];
            this.recentDocumentsFields = [];
            this.recentDocumentsFail = true;
            this.loadingMyRecentDocuments = false;
            console.log(error);
            this.showErrorMessage(error.headers.errorcode);
          });
      } catch (error) {
        this.recentDocumentsFail = true;
        this.loadingMyRecentDocuments = false;
        console.log(error);
      }
    },
    buildMyRecentDocument: function (doc) {
      try {
        let recentDocument = {};
        let newRecentDocumentFields = [];
        let newRecentDocumentFieldsInternalNames = [];

        //when there is no Document Properties
        if (!doc.DocumentProperties || doc.DocumentProperties.length <= 0) {
          recentDocument = {
            titel: doc.DocumentName ? doc.DocumentName : "",
            elev: doc.StudentFullName ? doc.StudentFullName : "",
            klasse: doc.GroupName ? doc.GroupName : "",
            DocumentId: doc.DocumentId ? doc.DocumentId : "",
          };
          newRecentDocumentFields.push("titel", "elev", "klasse");
          newRecentDocumentFieldsInternalNames.push(
            "DocumentName",
            "GroupName",
            "TemplateType"
          );
        } else {
          //when Document Properties are provided
          let properties = doc.DocumentProperties;
          properties.forEach((property) => {
            recentDocument[property.DisplayName] = property.Value
              ? property.Value
              : "";
            recentDocument.DocumentId = doc.DocumentId ? doc.DocumentId : "";
            newRecentDocumentFields.push(property.DisplayName);
            newRecentDocumentFieldsInternalNames.push(property.InternalName);
          });
          recentDocument.DocumentId = doc.DocumentId;
        }

        if (this.recentDocumentsFields.length <= 0) {
          this.recentDocumentsFields = newRecentDocumentFields;
          this.recentDocumentsFieldsInternalNames = newRecentDocumentFieldsInternalNames;
        }

        return recentDocument;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    getHeaders: function () {
      return {
        headers: {
          "Content-Type": "application/json",
          AulaToken: this.aulaToken,
        },
      };
    },
    getTemplates: function () {
      try {
        this.aulaTemplateTypes = [];
        this.loadingTemplates = true;
        let request = {
          AulaMunicipalityId: this.selectedMunicipalityId,
          InstitutionNumber: this.getInstitutionNumberFromContext,
          DocumentType: this.getDocumentTypeFromContext
        };
        let templateTypesResult = [{
          value: null,
          text: "",
          disabled: true,
          AulaTemplates: []
        }];

        this.axios
          .post(
            this.azureFunctionAppHostUrl + "/api/Templates",
            request,
            this.getHeaders()
          )
          .then((response) => {
            if (!response || !response.data) {
              this.loadingTemplates = false;
              return;
            }

            let templateDatas = response.data.TemplatesData;
            if (!templateDatas) {
              this.loadingTemplates = false;
              return;
            }

            if (templateDatas.length === 0) {
              //handle no template types
              this.loadingTemplates = false;
              return;
            }

            templateDatas.forEach((templateType) => {
              let templates =
                templateType.AulaTemplates.length > 0
                  ? templateType.AulaTemplates
                  : [];

              if (templates.length > 0) {
                templates.forEach((template) => {
                  template.TemplateType = templateType.Name;
                });
              }

              templateTypesResult.push({
                value: templateType.Name,
                text: templateType.Name,
                AulaTemplates: templates,
              });
            });

            this.aulaTemplateTypes = templateTypesResult;
            this.selectedTemplateType = this.aulaTemplateTypes[0].value;
            this.loadingTemplates = false;
          })
          .catch((error) => {
            this.loadingTemplates = false;
            console.log(error);
            this.showErrorMessage(error.headers.errorcode);
          });
      } catch (error) {
        console.log(error);
      }
    },
    loadDocuments: function (
      pageNo = null,
      sortColumn = null,
      sortMode = null,
      templateTypeFilter = null,
      searchPhrase = null
    ) {
      try {
        this.recentDocumentsItems = [];
        this.recentDocumentsFields = [];
        this.recentDocumentUpdatePropertyInProgress = [];

        this.loadingMyRecentDocuments = true;
        this.recentDocumentsFail = false;
        let pageNumber = pageNo ? pageNo : 1;
        this.currentPage = pageNumber;

        let request = {
          AulaMunicipalityId: this.selectedMunicipalityId,
          AulaId: this.getAulaIdFromContext,
          DocumentType: this.getDocumentTypeFromContext,
          Page: pageNumber,
          SortColumn: sortColumn,
          SortMode: sortMode,
          TemplateTypeFilter: templateTypeFilter,
          SearchPhrase: searchPhrase
        };

        this.axios
          .post(
            this.azureFunctionAppHostUrl + "/api/Documents",
            request,
            this.getHeaders()
          )
          .then((response) => {
            if (!response || !response.data) {
              this.recentDocumentsItems = [];
              this.recentDocumentsFields = [];
              this.loadingMyRecentDocuments = false;
              return;
            }

            let requestMunicipalityId = response.data.AulaMunicipalityId;
            let documentDatas = response.data.DocumentData;
            this.isPageLast = response.data.IsPageLast;

            if (
              requestMunicipalityId !== this.selectedMunicipalityId ||
              this.recentDocumentsItems.length > 0
            )
              return;

            if (!documentDatas) {
              this.recentDocumentsFail = true;
              this.loadingMyRecentDocuments = false;
              return;
            }

            let recentDocuments = [];
            let isRecentDocumentsFieldsConfigured = false;
            for (let index = 0; index < documentDatas.length; index++) {
              let doc = documentDatas[index];

              let recentDocument = this.buildStudentDocument(doc);
              if (recentDocument !== null) {
                recentDocuments.push(recentDocument);

                if (isRecentDocumentsFieldsConfigured) continue;

                let newRecentDocumentsFields = this.getRecentDocumentFields(doc, response.data.FieldConfigurations);
                if(newRecentDocumentsFields != null) {
                  this.recentDocumentsFields = newRecentDocumentsFields;
                  isRecentDocumentsFieldsConfigured = true;
                }
              }
            }

            if (!isRecentDocumentsFieldsConfigured) {
              this.recentDocumentsFields = this.getRecentDocumentFieldsForEmptyDocData(response.data.FieldConfigurations);
            }

            if(recentDocuments.length > 0){
              this.getSortOptions();
              this.anyDocumentsPresent = true;
            }

            if (!!recentDocuments) this.recentDocumentsItems = recentDocuments;
            this.initialRecentDocumentsItems = this.recentDocumentsItems;
            this.loadingMyRecentDocuments = false;
          })
          .catch((error) => {
            this.recentDocumentsItems = [];
            this.recentDocumentsFields = [];
            this.recentDocumentUpdatePropertyInProgress = [];
            this.recentDocumentsFail = true;
            this.loadingMyRecentDocuments = false;
            console.log(error);
            this.showErrorMessage(error.headers.errorcode);
          });
      } catch (error) {
        this.recentDocumentsFail = true;
        this.loadingMyRecentDocuments = false;
        console.log(error);
      }
    },
    getRecentDocumentFields: function (doc, fieldConfigurations) {
      try {
        let newRecentDocumentFields = [];

        if (!doc.DocumentProperties || doc.DocumentProperties <= 0) {
          newRecentDocumentFields.push(
            { key: "DocumentName", label:"titel" },
            { key: "GroupName", label:"klasse" },
            { key: "TemplateType", label:"dokumentstype" }
          );
        } else {
          let properties = doc.DocumentProperties;
          properties.forEach((property) => {
            let recentDocumentField = { key: property.InternalName, label: property.DisplayName };
            if (fieldConfigurations != null && fieldConfigurations.length > 0) {
              let fieldConfiguration = fieldConfigurations.find((x) => x.InternalName === property.InternalName);
              if (fieldConfiguration != null) {
                recentDocumentField.FieldType = fieldConfiguration.FieldType ? fieldConfiguration.FieldType : "";
                recentDocumentField.IsEditable = fieldConfiguration.IsEditable ? fieldConfiguration.IsEditable : false;
              }
            }
            newRecentDocumentFields.push(recentDocumentField);
          });
        }

        return newRecentDocumentFields;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    getRecentDocumentFieldsForEmptyDocData: function (fieldConfigurations) {
      try {

        if (fieldConfigurations == null || fieldConfigurations.length === 0) return [];

        let newRecentDocumentFields = [];

        fieldConfigurations.forEach((fieldConfiguration) => {
          newRecentDocumentFields.push({
            key: fieldConfiguration.InternalName,
            label: fieldConfiguration.DisplayName ? fieldConfiguration.DisplayName : fieldConfiguration.InternalName,
            FieldType: fieldConfiguration.FieldType ? fieldConfiguration.FieldType : "",
            IsEditable: fieldConfiguration.IsEditable ? fieldConfiguration.IsEditable : false
          })
        });

        return newRecentDocumentFields;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    buildStudentDocument: function (doc) {
      try {
        let recentDocument = {};

        //when there is no Document Properties
        if (!doc.DocumentProperties || doc.DocumentProperties <= 0) {
          recentDocument = {
            titel: doc.DocumentName ? doc.DocumentName : "",
            elev: doc.StudentFullName ? doc.StudentFullName : "",
            klasse: doc.GroupName ? doc.GroupName : "",
            dokumentstype: doc.TemplateType ? doc.TemplateType : "",
            DocumentId: doc.DocumentId ? doc.DocumentId : "",
          };
        } else {
          //when Document Properties are provided
          let properties = doc.DocumentProperties;
          properties.forEach((property) => {
            recentDocument[property.InternalName] = property.Value
              ? property.Value
              : "";
            recentDocument.DocumentId = doc.DocumentId ? doc.DocumentId : "";
          });
          recentDocument.DocumentId = doc.DocumentId;
          recentDocument[this.consts.DOC_LOADING_FIELD_NAME] = false;
        }

        return recentDocument;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    updateDocumentProperty: function (
      index,
      documentId,
      internalName,
      displayName,
      value
    ) {
      this.recentDocumentUpdatePropertyInProgress.push({Index: index, InternalName: internalName});
      this.updateRecentDocumentItem(true, index, this.consts.DOC_LOADING_FIELD_NAME);

      let request = {
        DocumentId: documentId,
        DocumentProperties: [{InternalName: internalName, Value: value}],
        AulaMunicipalityId: this.selectedMunicipalityId,
      };

      this.axios
        .post(
          this.azureFunctionAppHostUrl + "/api/UpdateDocumentProperties",
          request,
          this.getHeaders()
        )
        .then(() => {
          this.recentDocumentUpdatePropertyInProgress = this.recentDocumentUpdatePropertyInProgress.filter((x) => (x.Index != index && x.InternalName != internalName));
          this.updateRecentDocumentItem(false, index, this.consts.DOC_LOADING_FIELD_NAME);
        })
        .catch((error) => {
          this.recentDocumentUpdatePropertyInProgress = this.recentDocumentUpdatePropertyInProgress.filter((x) => (x.Index != index && x.InternalName != internalName));
          this.updateRecentDocumentItem(false, index, this.consts.DOC_LOADING_FIELD_NAME);
          this.showErrorMessage(error.headers.errorcode, displayName ? displayName : 'Dokumentegenskaben');
          this.reloadDocuments();
          console.log(error);
        });
    },
    getSortOptions: function () {
      let sortOptions = this.getNoSortingOption();

      for (let index = 0; index < this.recentDocumentsFields.length; index++) {
        sortOptions.push({
          value: this.recentDocumentsFields[index].key + "#;Asc_",
          text: `Sortér på ${this.recentDocumentsFields[index].label} (stigende)`,
        });
        sortOptions.push({
          value: this.recentDocumentsFields[index].key + "#;Desc_",
          text: `Sortér på ${this.recentDocumentsFields[index].label} (faldende)`,
        });
      }

      this.sortOptions = sortOptions;
    },
    getDocumentFilterOptions: function() {
      let filterOptions = this.getNotFilteringOption();

      if (this.aulaTemplateTypes !== null) {
        this.aulaTemplateTypes.forEach(templateObj => {
          if(templateObj && !templateObj.disabled) {
            filterOptions.push(templateObj);
          }
        });
      }

      this.documentFilterOptions = filterOptions;
    },
    clearSortFilterSearch: function(){
      this.currentPage = null;
      this.sortOptions = [];
      this.selectedSortOption = null;
      this.documentFilterOptions = [];
      this.documentFilterOption = null;
      this.documentSearchPhrase = null;
    },
    refreshDocuments: function () {
      this.isStudentOrClassFound
        ? this.reloadDocuments()
        : this.loadMyRecentDocuments();
    },
    reloadDocuments: function(pageNo = null) {
      if (pageNo !== null) {
        this.currentPage = pageNo;
      }

      this.loadDocuments(this.currentPage, this.sortColumn, this.sortMode, this.documentFilterOption, this.documentSearchPhrase);
    },
    getNoSortingOption: function (){
      return [{ value: null, text: this.translations.noSorting }];
    },
    getNotFilteringOption: function(){
      return [{ value: null, text: this.translations.noFiltering, AulaTemplates: [] }];
    },
    setMunicipalityLocalStorage: function() {
      localStorage.setItem(this.consts.MUNICIPALITY_LOCAL_STORAGE_NAME, this.selectedMunicipalityId);
    },
    getMunicipalityLocalStorageValue: function() {
      try {
        let retVal = parseInt(localStorage.getItem(this.consts.MUNICIPALITY_LOCAL_STORAGE_NAME));

        return isNaN(retVal) ? null : retVal;
      } catch (error) {
        return null;
      }
    }
  },
  computed: {
    getEditableBoolRecentDocumentFields: function () {
      return this.recentDocumentsFields?.filter((field) => field.IsEditable === true && (field.FieldType === 'Bool' || field.FieldType === 2))//2 = Bool
    },
    filteredDocumentTemplates: function () {
      this.currentTemplateIndex = -1;
      this.pickedDocumentTemplate = null;
      if (!this.documentTemplates || this.documentTemplates.length === 0)
        return [];
      return this.documentTemplates.filter(
        (template) => template.TemplateType === this.selectedTemplateType
      );
    },
    allStudents: function () {
      let allStudents = [];

      for (let i = 0; i < this.searchData.length; i++) {
        let currentClass = this.searchData[i];
        let thisClassStudents = [];
        thisClassStudents.push(...currentClass.StudentDatas);

        thisClassStudents.forEach((student) => {
          student.DisplayName = student.FullName;
          student.Group = currentClass.GroupName;
          student.keyVal = `${student.AulaStudentId}_${currentClass.GroupId}`;
        });

        allStudents.push(...thisClassStudents);
      }

      return allStudents;
    },
    documentTemplates: function () {
      let templates = [];

      this.aulaTemplateTypes.forEach((templateType) => {
        if (
          !templateType.AulaTemplates ||
          templateType.AulaTemplates.length === 0
        )
          return templates;
        templates.push(...templateType.AulaTemplates);
      });

      return templates;
    },
    groupNamesDictionary: function() {
      let groupDict = {};

      this.searchData.forEach(g => {
        groupDict[g.GroupId] = g.GroupName;
      })

      return groupDict;
    },
    isUserAllowedToGetData: function () {
      let selectedMunicipalityIndex = this.municipalities.findIndex(
        (mun) => mun.value === this.selectedMunicipalityId
      );
      let shouldCheckAssuranceLevel = this.municipalities[selectedMunicipalityIndex].shouldCheckAssuranceLevel;
      return !shouldCheckAssuranceLevel || !!shouldCheckAssuranceLevel && this.assuranceLevel === 3;
    },
    isClassWithoutCaseFound: function () {
      return this.foundGroup && !this.foundGroup.HasAulaClassCase;
    },
    isClassFound: function () {
      return this.foundGroup && this.foundGroup.HasAulaClassCase;
    },
    isStudentOrClassFound: function () {
      return this.foundPerson || this.isClassFound;
    },
    getDocumentTypeFromContext: function () {
      return this.foundPerson ? 0 : this.isClassFound ? 1 : null;
    },
    getInstitutionNumberFromContext: function () {
      return this.foundPerson
        ? this.foundPerson.InstitutionNumber
        : this.isClassFound
          ? this.foundGroup.InstitutionNumber
          : null;
    },
    getAulaIdFromContext: function () {
      switch(this.getDocumentTypeFromContext) {
        case 0:
          return this.foundPerson.AulaStudentId;
        case 1:
          return this.foundGroup.GroupId;
        default:
          return null;
      }
    },
  },
  created() {
    try {
      this.axios.interceptors.response.use(
        (res) => res,
        (e) => {
          console.log(e);
          return e.response ? Promise.reject(e.response) : Promise.reject(e);
        }
      );
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    try {
      this.aulaToken = this.getAulaToken();
    } catch (error) {
      console.log(error);
    }
  },
  watch: {
    createDocumentNewTitle: function(val, oldVal) {
      this.documentNameContainsIllegalCharacter = this.consts.ILLEGAL_CHARACTERS_REGEX.test(val);
      this.documentNameIsTooLong = val && val.length > 150;
    },
    recentDocumentsItems: function() {
      this.documentLoading = this.recentDocumentsItems &&
        this.recentDocumentsItems.length > 0 &&
        this.recentDocumentsItems.some(x => x[this.consts.DOC_LOADING_FIELD_NAME] === true);
    },
    aulaToken: function () {
      if (this.aulaToken != undefined) {
        if (this.municipalities.length === 0) this.getMembership();
        setTimeout(() => {
          this.aulaToken = this.getAulaToken();
        }, 240000);
      }
    },
    selectedMunicipalityId: function () {
      this.recentDocumentsItems = [];
      this.searchData = [];
      this.refreshWidget();
      this.showErrorAlert = false;
      this.showSuccessAlert = false;

      var selectedMunicipalityIndex = this.municipalities.findIndex(
        (mun) => mun.value === this.selectedMunicipalityId
      );

      if (this.selectedMunicipalityId !== null) {
        if(this.selectedMunicipalityId !== this.municipalityLocalStorage){
          this.setMunicipalityLocalStorage();
        }

        this.checkAssuranceLevel = this.municipalities[selectedMunicipalityIndex].shouldCheckAssuranceLevel;

        selectedMunicipalityIndex !== -1 &&
        this.municipalities[selectedMunicipalityIndex].isOneDriveAccountSet === true &&
        !!this.isUserAllowedToGetData &&
        !this.isServiceMode
          ? this.loadSearchData()
          : selectedMunicipalityIndex !== 0
            ? this.showCustomErrorMessage(
              this.translations.errors.noOneDriveAccount
            )
            : null;
      }
      else {
        this.checkAssuranceLevel = false;
      }
    },
    selectedSortOption: function () {
      //0 - none
      //1 - ascending
      //2 - descending
      let mode = 0;
      if (this.selectedSortOption === null) {
        this.sortColumn = null;
        this.sortMode = null;
      }
      else {
        let option = this.selectedSortOption.split("#;");

        if (option[1] === "Asc_") {
          mode = 1;
        }
        if (option[1] === "Desc_") {
          mode = 2;
        }

        this.sortColumn = option[0];
        this.sortMode = mode;
      }

      this.reloadDocuments(1);
    },
    documentFilterOption: function () {
      this.reloadDocuments(1);
    },
    loadingTemplates: function(){
      this.getDocumentFilterOptions();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.widget-W0075V0001 {
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  .searchIcon {
    font-size: 26px;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    padding-bottom: 10px;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  #typeAheadContainer {
    position: absolute;
    padding: 0;
    margin-top: -10px;
    /* min-width: 100%; */
    background-color: #fff;
    list-style: none;
    /* border-radius: 4px; */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    z-index: 1000;
    border-radius: 4px;
    max-height: 217px;
    overflow: auto;
  }
  #typeAheadResult {
    padding: 10px 16px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    display: block;
    margin: 0px;
  }
  #typeAheadResult:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  #typeAheadResult:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom: 0;
  }
  .active {
    background-color: #3aa373;
  }
  .active span {
    color: white;
  }
  .activePupil .list-group-item {
    background-color: #3aa373;
    color: white;
  }
  #pupilItem {
    cursor: pointer;
  }
  .hoverStudent .list-group-item {
    background-color: rgb(34, 35, 80);
    color: white;
  }
  #classWrapper {
    max-height: 242px;
    overflow: auto;
    margin-bottom: 10px;
  }
  #refreshTitle {
    cursor: pointer;
  }
  .theme-employee .btn-primary.disabled,
  .btn-primary:disabled {
    background: #f6f7f8;
    border: solid #d9dfe3;
    border-width: 2px;
    color: #d9dfe3;
    font-weight: bold;
  }
  .icon-Aula_search {
    position: absolute;
    right: 18px;
    top: 18px;
    cursor: auto;
  }
  .bold {
    font-weight: bold;
  }
  input[type="text"].form-control:disabled,
  input[type="password"]:disabled,
  input[type="email"]:disabled,
  input[type="number"]:disabled,
  input[type="url"]:disabled,
  input[type="tel"]:disabled,
  input[type="date"]:disabled,
  input[type="time"]:disabled,
  select.form-control:disabled,
  textarea.form-control:disabled {
    border: solid #d9dfe3;
    border-width: 2px;
  }
  .tooltip .tooltip-inner {
    color: #222350 !important;
  }
  .error {
    color: #b50050;
  }
  .success {
    color: #3aa373;
  }
  .typeAheadAddInfo {
    color: #549ec7;
  }
  .searchErrorRow {
    padding-bottom: 10px;
  }
  .recentDocumentInfo {
    padding-left: 10px;
  }
  .inline {
    display: inline-block;
  }
  .showPointer {
    cursor: pointer;
  }
  .recentDocumentsRowInactive > td,
  .showNotAllowed
  {
    cursor: not-allowed;
  }
  .container {
    padding-top: 10px;
  }
  .labelWithSpinner {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    height: 32px;
  }
  .labelWithSpinner h5 {
    margin: auto 0;
  }
  .illegalCharactersInfo {
    margin-top: -8px;
    margin-bottom: 10px;
  }
  .checkboxContainer {
    display: flex;
    justify-content: center;

    .custom-switch {
      margin-top: 3px;
      margin-right: 10px
    }
    > div > label {
      display: inline;
      cursor: inherit;
    }
  }
  .hideHeader {
    display: none;
  }
  .showHeader {
    display: unset;
  }
  .disablePointerEvents {
    pointer-events: none;
  }
  .smallCellTable {
    padding: 12px 18px;
  }
  .classText {
    color: #2091A2;
  }
  .service {
    font-size: 46px;
  }
}
</style>
